export default "__VITE_ASSET__BM9t6iUw__"